import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import './TimeStepLabels.scss'
import { listTimes } from '@teqplay/viewer'

const FORMAT = {
  millisecond: 'SSS\\m\\s',
  second: 's\\s',
  minute: 'YYYY/MM/DD ddd HH:mm',
  hour: 'YYYY/MM/DD ddd HH:mm',
  weekday: 'YYYY/MM/DD ddd',
  day: 'YYYY/MM/DD',
  month: 'YYYY/MM',
  year: 'YYYY'
}

export default class TimeStepLabels extends PureComponent {
  static propTypes = {
    startTime: PropTypes.object.isRequired,
    endTime: PropTypes.object.isRequired,
    timeToScreen: PropTypes.func.isRequired
  }

  render() {
    const times = listTimes(this.props.startTime, this.props.endTime)

    return (
      <div className="time-axis">
        {times.map((time, index) => {
          const top = this.props.timeToScreen(time)
          const nextTime = index === 0 ? index + 1 : index - 1
          const timeDifference = Math.abs(moment(time).valueOf() - moment(times[nextTime]).valueOf())

          if (isNaN(top)) {
            return null
          }

          return (
            <div key={index} style={{ top }} className="time-axis-item">
              <div className="label">{moment(time).format(this.getDateTimeFormat(timeDifference))}</div>
            </div>
          )
        })}
      </div>
    )
  }

  /**
   * Determine the step value and scale
   * @param {number} timeDifference
   * @returns {string}
   */
  getDateTimeFormat = timeDifference => {
    const stepYear = 1000 * 60 * 60 * 24 * 30 * 12
    const stepMonth = 1000 * 60 * 60 * 24 * 30
    const stepDay = 1000 * 60 * 60 * 24
    const stepHour = 1000 * 60 * 60
    const stepMinute = 1000 * 60
    const stepSecond = 1000

    if (timeDifference >= stepYear) {
      return FORMAT.year
    }

    if (timeDifference >= stepMonth) {
      return FORMAT.month
    }

    if (timeDifference >= stepDay / 2) {
      return FORMAT.weekday
    }

    if (timeDifference >= stepDay) {
      return FORMAT.day
    }

    if (timeDifference >= stepHour) {
      return FORMAT.hour
    }

    if (timeDifference >= stepMinute) {
      return FORMAT.minute
    }

    if (timeDifference >= stepSecond) {
      return FORMAT.second
    }

    return FORMAT.millisecond
  }
}
